import { createAction, props } from '@ngrx/store';

import { ICompanyPreferences } from '@shared/types/company/company-preferences.type';

export const SET_COMPANY_PREFERENCES = 'SET_COMPANY_PREFERENCES';
export const SET_COMPANY_PREFERENCES_FAILURE = 'SET_COMPANY_PREFERENCES_FAILURE';
export const SET_COMPANY_PREFERENCES_SUCCESS = 'SET_COMPANY_PREFERENCES_SUCCESS';

export const set_company_preferences = createAction(
    `[COMPANY_REDUCER] ${SET_COMPANY_PREFERENCES}`,
    props<{ id: string }>(),
);
export const set_company_preferences_failure = createAction(`[COMPANY_REDUCER] ${SET_COMPANY_PREFERENCES_FAILURE}`);
export const set_company_preferences_success = createAction(
    `[COMPANY_REDUCER] ${SET_COMPANY_PREFERENCES_SUCCESS}`,
    props<{ preferences: ICompanyPreferences }>(),
);
